import { Link } from 'react-router-dom';
import styles from './JeffRhatiganPage.module.css';

// ---- Inline SVG icons (no extra dependencies) ----

const IconGlobe = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const IconLinkedIn = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect x="2" y="9" width="4" height="12" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

const IconMail = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

// ---- Page data ---- (edit here to update the card)

const PERSONA = {
  name: 'Jeff Rhatigan',
  title: 'Chief Technologist\nAI Systems & Architecture',
  // Drop your photo at: packages/console/public/images/jeff.png
  photoUrl: `${process.env.PUBLIC_URL}/images/jeff.png`,
  ctas: [
    {
      label: 'LinkedIn',
      href: 'https://www.linkedin.com/in/jeff-rhatigan/',
      style: 'secondary',
      icon: <IconLinkedIn />,
    },
    {
      label: 'My Website',
      href: 'https://rhatigan.ai/',
      style: 'primary',
      icon: <IconGlobe />,
    },
    {
      label: 'jeff@rhatigan.ai',
      href: 'mailto:jeff@rhatigan.ai',
      style: 'email',
      icon: <IconMail />,
    },
  ],
};

// ---- Component ----

const JeffRhatiganPage = () => {
  const ctaClass = {
    primary: styles.ctaPrimary,
    secondary: styles.ctaSecondary,
    email: styles.ctaEmail,
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>

        {/* Avatar */}
        <div className={styles.avatarWrap}>
          <img
            src={PERSONA.photoUrl}
            alt={PERSONA.name}
            className={styles.avatar}
            onError={(e) => {
              // If photo hasn't been uploaded yet, show initials placeholder
              e.currentTarget.style.display = 'none';
              e.currentTarget.nextSibling.style.display = 'flex';
            }}
          />
          <div className={styles.avatarPlaceholder} style={{ display: 'none' }}>
            JR
          </div>
        </div>

        {/* Identity */}
        <div className={styles.identity}>
          <h1 className={styles.name}>{PERSONA.name}</h1>
          <p className={styles.title}>
            {PERSONA.title.split('\n').map((line, i) => (
              <span key={i}>
                {line}
                {i < PERSONA.title.split('\n').length - 1 && <br />}
              </span>
            ))}
          </p>
        </div>

        <hr className={styles.divider} />

        {/* Maintenance notice */}
        <div className={styles.maintenanceBanner}>
            <strong>AI Assistant — temporarily offline</strong>
            Jeff&apos;s AI persona is currently undergoing updates. For now, feel free to connect directly using the links below.
        </div>

        {/* CTA links */}
        <ul className={styles.ctaList}>
          {PERSONA.ctas.map(({ label, href, style, icon }) => (
            <li key={href}>
              <a
                href={href}
                target={href.startsWith('mailto') ? '_self' : '_blank'}
                rel="noopener noreferrer"
                className={`${styles.ctaButton} ${ctaClass[style]}`}
              >
                {icon}
                {label}
              </a>
            </li>
          ))}
        </ul>

      </div>

      {/* Footer */}
      <footer className={styles.footer}>
        Powered by{' '}
        <Link to="/" className={styles.footerLink}>
          Ego Protocol · Digital Identity Infrastructure
        </Link>
      </footer>
    </div>
  );
};

export default JeffRhatiganPage;
